var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(" User Name: "),_c('br'),_vm._t("default",[_vm._v(_vm._s(_vm.user.Name))],{"user":_vm.user})],2),_c('br'),_c('span',[_vm._t("position",null,{"position":_vm.user.JobTitle})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }